import {userGetters} from "@/store/getters/user";
// import {operateGetters} from "@/store/getters/operate";
// import {taskGetters} from "@/store/getters/task";
// import {analysisGetters} from "@/store/getters/analysis";
import {zcGetters} from "@/store/getters/zc";

import {screenGetters} from "@/store/getters/screen";
import {indexGetters} from "@/store/getters/index";
import {roleGetters} from "@/store/getters/role";
import {settingGetters} from "@/store/getters/setting";
import {workSheetGetters} from "@/store/getters/workSheet";
import {bdGetters} from "@/store/getters/bd";

const getters = {
    ...userGetters,
    // ...operateGetters,
    // ...analysisGetters,
    // ...taskGetters,
    ...screenGetters,
    ...indexGetters,
    ...settingGetters,
    ...roleGetters,
    ...workSheetGetters,
    ...bdGetters,
    ...zcGetters,
};
export default getters
